import React, {useEffect, useState} from "react";
import classes from "../forms/forms.module.css";

export default function UploadFileDialog({text, accept, onChange, isOpen, onClose, onSubmit}) {

    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        if (!isOpen) return;
        const handleEsc = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        const file = e.target.elements.file.files[0];
        if (file) {
            setDisabled(true);
            setLoading(true);
            onSubmit(file);
            setDisabled(false);
            setLoading(false);
        }
    };

    return (
        <div className={classes.backdrop} onClick={onClose}>
            <div className={classes.modalCconfirm} onClick={(e) => e.stopPropagation()}>
                <h5 className="mb-3 text-center">{text || "📁 Загрузка файла"}</h5>

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <input
                            type="file"
                            name="file"
                            accept={accept}
                            onChange={onChange}
                            className={classes.fileInput}
                            required
                        />
                    </div>

                    <div className={classes.modalButtons}>
                        <button type="submit" className={classes.submit}
                                disabled={disabled || loading}>
                            {loading? <div>
                                <svg width="24" height="24" viewBox="0 0 50 50">
                                    <circle
                                        cx="25"
                                        cy="25"
                                        r="20"
                                        stroke="rgba(255,255,255,0.2)"
                                        strokeWidth="4"
                                        fill="none"
                                    />
                                    <circle
                                        cx="25"
                                        cy="25"
                                        r="20"
                                        stroke="#fff"
                                        strokeWidth="4"
                                        fill="none"
                                        strokeDasharray="30 94"
                                        strokeLinecap="round"
                                    >
                                        <animateTransform
                                            attributeName="transform"
                                            type="rotate"
                                            values="0 25 25;180 25 25;0 25 25"
                                            dur="1.5s"
                                            repeatCount="indefinite"
                                            calcMode="spline"
                                            keyTimes="0;0.5;1"
                                            keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
                                        />
                                    </circle>
                                </svg>
                            </div> : '✅ Загрузить'}

                        </button>
                        <button type="button" className={classes.noSubmit} onClick={onClose}>
                            ❌ Отмена
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
